import { useEffect } from "react";
import { useRequestMutation } from "hooks/useRequest";
import { History } from "models/AiResearch";

export const useHistoryList = () => {
  // 過去のチャット履歴を取得
  const {
    data: { historys: history } = { historys: [] },
    trigger: triggerHistoryList
  } = useRequestMutation<{
    historys: History[];
  }>("/sse/query/rag/history-list");

  // 初期表示時、過去のチャット履歴を取得
  useEffect(() => {
    triggerHistoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { history, fetchHistoryList: triggerHistoryList };
};
